import { render, staticRenderFns } from "./ItemFull.vue?vue&type=template&id=2d962c97&scoped=true&"
var script = {}
import style0 from "./ItemFull.vue?vue&type=style&index=0&id=2d962c97&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d962c97",
  null
  
)

export default component.exports